import React from "react";
import "./style.css";

const SummaryInfoBar = ({
  metrics = [],
  meta = [],
}) => {
  return (
    <div className="summary-bar">
      {/* Left Metrics */}
      <div className="summary-metrics">
        {metrics.map((item, index) => (
          <div className="metric-item" key={index}>
            <div className="metric-label">{item.label}</div>
            <div className="metric-value">{item.value}</div>
          </div>
        ))}
      </div>

      {/* Divider */}
      <div className="summary-divider" />

      {/* Right Meta Info */}
      <div className="summary-meta">
        {meta.map((item, index) => (
          <div className="meta-item" key={index}>
            <div className="meta-header">
              {item.icon && (
                <img
                  src={item.icon}
                  alt="icon"
                  className="meta-icon"
                />
              )}
              <div className="meta-label">{item.label}</div>
            </div>
            <div>
              <div className="meta-value">{item.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryInfoBar;